import { configureStore } from "@reduxjs/toolkit";
import posFiltersReducer from "./slices/posFilters";
import proposalOldReducer from "./slices/proposal_old";
import proposalReducer from "./slices/proposal";
import promotionsReducer from "./slices/promotions";

const reducer = {
  posFilters: posFiltersReducer,
  proposal_old: proposalOldReducer,
  proposal: proposalReducer,
  promotions: promotionsReducer,
};

export const store = configureStore({
  reducer,
  devTools: {
    maxAge: 500,
  }, //process.env.NODE_ENV !== 'production',
});

export type Dispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
